import { toPrice, parseDecimal } from 'utils/converters';

export function unidadeQuantidadeCurta(tipoTaraBalaios) {
  if (tipoTaraBalaios === 'Pes') return 'UN';
  if (tipoTaraBalaios === 'L') return 'L';
  if (tipoTaraBalaios === 'Kg') return 'Kg';
  return '';
}

export function formatQuantidadeComUnidade(quantidade, tipoTaraBalaios) {
  const base = toPrice(quantidade);
  const u = unidadeQuantidadeCurta(tipoTaraBalaios);
  return u ? `${base} ${u}` : base;
}

export function medidasPorTara(quantidade, standardUnitValue) {
  const tara = parseDecimal(standardUnitValue);
  if (tara <= 0) return null;
  const q = parseDecimal(quantidade);
  return q / tara;
}

export function formatMedidas(quantidade, standardUnitValue) {
  const m = medidasPorTara(quantidade, standardUnitValue);
  if (m == null) return '—';
  return `${toPrice(m)} UN`;
}

export function quantidadeDoLote(option) {
  return option?.quantidade ?? option?.qtd ?? option?.quantidade_total ?? 0;
}

function pickTrim(...vals) {
  const first = vals
    .map((v) => (v == null ? '' : String(v).trim()))
    .find((s) => !!s);
  return first || '';
}

/**
 * Código exibido no select da rastreabilidade (ex.: armazém).
 * Prioridade: codigo_lote / codigoLote (saídas, rebenefício) → codigo → codigo_processo.
 */
export function codigoCompletoEtiquetaLote(option) {
  if (!option || typeof option !== 'object') return '';
  return pickTrim(
    option.codigo_lote,
    option.codigoLote,
    option.codigo,
    option.codigo_processo,
    option.codigoProcesso,
  );
}

function qualidadeEtiquetaLote(option) {
  return pickTrim(
    option?.qualidade,
    option?.nome_qualidade,
    option?.nomeQualidade,
    option?.descricao_qualidade,
    option?.descricaoQualidade,
    option?.classificacao,
    option?.classificacao_qualidade,
    option?.classificacaoQualidade,
  );
}

export function formatEtiquetaLoteSelect(
  option,
  tipoTaraBalaios,
  standardUnitValue,
) {
  const codigoStr = codigoCompletoEtiquetaLote(option);
  if (!codigoStr) return '';
  const q = quantidadeDoLote(option);
  const qual = qualidadeEtiquetaLote(option);
  const qualPart = qual ? ` · ${qual}` : '';
  return `${codigoStr}${qualPart} · ${formatQuantidadeComUnidade(
    q,
    tipoTaraBalaios,
  )} · ${formatMedidas(q, standardUnitValue)}`;
}

